export default __webpack_public_path__ + "static/media/fuzzing-full-web.1c7fb29e.avif";